import React, { useState } from 'react';
import { X, Trash2, AlertTriangle, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';
import api from '../../services/api';

const DeleteSubscriptionModal = ({ subscription, client, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const handleDelete = async () => {
    setLoading(true);
    setError('');
    
    try {
      const response = await api.delete(`/admin/subscriptions/${subscription.id}`);
      setResult(response.data);
      setTimeout(() => {
        onSuccess();
        onClose();
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur lors de la suppression');
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-[#1A1A1D] rounded-lg metallic-border max-w-md w-full p-6"
      >
        {result ? (
          <div className="text-center py-6">
            <div className="w-16 h-16 bg-[#00FF88]/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Trash2 className="h-8 w-8 text-[#00FF88]" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Suppression effectuée</h3>
            <p className="text-[#B8B8BA]">{result.message}</p>
          </div>
        ) : (
          <>
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-white flex items-center space-x-2">
                <AlertTriangle className="h-5 w-5 text-[#FF3B5C]" />
                <span>Supprimer l'abonnement</span>
              </h3>
              <button
                onClick={onClose}
                className="text-[#6B6B6E] hover:text-white"
                disabled={loading}
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            <div className="bg-[#FF3B5C]/10 border border-[#FF3B5C]/30 p-4 rounded-lg mb-4">
              <p className="text-[#FF3B5C] text-sm mb-3">
                ⚠️ Attention : Cette action est irréversible !
              </p>
              <div className="text-white space-y-1">
                <div><strong>Client :</strong> {client.full_name}</div>
                <div className="text-sm text-[#B8B8BA]">{client.email}</div>
                <div className="mt-2 text-sm">
                  <strong>Période :</strong> {new Date(subscription.start_date).toLocaleDateString('fr-FR')} → {new Date(subscription.end_date).toLocaleDateString('fr-FR')}
                </div>
                <div className="text-sm">
                  <strong>Statut :</strong> <span className="text-[#FFB800]">{subscription.status}</span>
                </div>
              </div>
            </div>

            {error && (
              <div className="bg-[#FF3B5C]/10 border border-[#FF3B5C] rounded-lg p-3 mb-4">
                <p className="text-[#FF3B5C] text-sm">{error}</p>
              </div>
            )}

            <div className="bg-[#FF3B5C]/10 p-3 rounded-lg mb-4 border border-[#FF3B5C]/30">
              <p className="text-[#FF3B5C] text-sm">
                🗑️ <strong>L'abonnement ET les identifiants IPTV associés seront supprimés définitivement.</strong>
              </p>
            </div>

            <div className="flex space-x-3">
              <button
                onClick={handleDelete}
                disabled={loading}
                className="flex-1 bg-[#FF3B5C] hover:bg-[#FF2244] text-white font-semibold py-3 rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
              >
                {loading ? (
                  <>
                    <Loader2 className="h-5 w-5 animate-spin" />
                    <span>Suppression...</span>
                  </>
                ) : (
                  <>
                    <Trash2 className="h-5 w-5" />
                    <span>Confirmer la suppression</span>
                  </>
                )}
              </button>
              <button
                onClick={onClose}
                disabled={loading}
                className="px-6 py-3 bg-[#3A3A3D] hover:bg-[#4A4A4D] text-white rounded-lg transition-all disabled:opacity-50"
              >
                Annuler
              </button>
            </div>
          </>
        )}
      </motion.div>
    </div>
  );
};

export default DeleteSubscriptionModal;
